module.exports = __webpack_public_path__ + "static/img/person1.fe0a860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person1.png
// module id = 0V7U
// module chunks = 1